import React from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";

import { styles } from "./styles";

export const NpsQuestion = props => {
  const { question, selectedOptions, selectOption, lang } = props;

  const descriptions = {
    positive: {
      text:
        question?.options[question.options.length - 1].other_text_placeholder,
      text_urdu: "ضرور",
    },
    negative: {
      text: question?.options[0].other_text_placeholder,
      text_urdu: "بلکل نہیں",
    },
  };
  const useLargeScoreBox = question.options.length <= 5;

  return (
    <View>
      <View style={styles.scoreList}>
        {question.options.map(option => {
          const label = {
            score: option[lang],
            selected: !!selectedOptions[option.virtual_id],
            onPress: () => selectOption(question, option),
          };
          return (
            <Box
              key={option.virtual_id}
              label={label}
              image={option.image}
              large={useLargeScoreBox}
            />
          );
        })}
      </View>
      <View style={styles.descriptionContainer}>
        <Description text={descriptions.negative[lang]} align="left" />
        <Description text={descriptions.positive[lang]} align="right" />
      </View>
    </View>
  );
};

const Box = ({ image, ...rest }) => {
  return (
    <View style={styles.rangePadding}>
      {image && <ScoreImage image={image} />}
      <Label {...rest} />
    </View>
  );
};

export const Description = ({ text, align }) => (
  <Text style={[styles.description, { textAlign: align }]}>{text}</Text>
);

export const Label = ({ label, large }) => {
  const { onPress, score, selected } = label;
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.score,
        large && styles.scoreLarge,
        selected && styles.scoreSelected,
      ]}
    >
      <Text style={[styles.scoreLabel, selected && styles.scoreLabelSelected]}>
        {score}
      </Text>
    </TouchableOpacity>
  );
};

export const ScoreImage = ({ image, style }) => (
  <View style={[styles.score, styles.image, style]}>
    <Image style={{ flex: 1, width: null, height: null }} source={image} />
  </View>
);
